var exports = {
  "wrapper": "xaee3c4fa--b0e489--wrapper",
  "_top": "xaee3c4fa--b0e489--_top",
};

module.exports = exports;
